module.exports = "<span class=\"badge-product badge--circle\" ng-class=\"::ctrl.classes\">\r\n    <span class=\"badge_title\" ng-bind-html=\"::ctrl.content\"></span>\r\n</span>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/badges/badge-template.html
 ** module id = 888
 ** module chunks = 1
 **/